import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pin-input" }
const _hoisted_2 = { class: "pin-input__fields" }
const _hoisted_3 = ["onUpdate:modelValue", "onKeydown", "onKeyup"]
const _hoisted_4 = { class: "pin-input__info" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "pin-input__resend-container" }
const _hoisted_8 = {
  key: 0,
  class: "pin-input__resend"
}
const _hoisted_9 = {
  key: 1,
  class: "pin-input__resend-success"
}
const _hoisted_10 = {
  key: 2,
  class: "pin-input__resend-fail"
}

import { ref, computed, onMounted, watch } from "vue";
import AccountInput from "./account-input.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pin-input',
  props: /*@__PURE__*/_mergeModels({
    modelValue: {},
    name: {},
    phoneNumber: {}
  }, {
    "errorMessage": {},
    "errorMessageModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue", "resendPin", "inputErrorDetected"], ["update:errorMessage"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const phoneNumberFormatted = computed(() => {
    const number = props.phoneNumber;
    if (!number) return "";
    return number.slice(0, 4) + " " + number.slice(4, 7) + " " + number.slice(7, 10) + " " + number.slice(10, 13);
});

const inputValues = [ref(""), ref(""), ref(""), ref("")];

const inputRefs = ref<HTMLInputElement[]>([]);

const getCode = () =>
    inputValues.map((inputValueRef) => inputValueRef.value).reduce((prevValue, inputValue) => prevValue + inputValue);

/*  MUST BE CRAZY SOLUTION BECAUSE OLD ANDROIND IS SHIT -> dont support key detection. */
watch(
    () => inputValues,
    () => {
        emit("update:modelValue", getCode());
    },
    {
        deep: true,
    }
);

let isSecondLetter = false;
const enabledKeys = ["Unidentified", "Delete", "Backspace", "ArrowLeft", "ArrowRight", "Tab"];
const keyDownEventHandler = (event: KeyboardEvent, index: number) => {
    console.log(event, index);
    if ((event.key < "0" || event.key > "9") && !enabledKeys.find((enabledKey) => enabledKey == event.key)) {
        event.preventDefault();
    }

    isSecondLetter = inputRefs.value[index].selectionStart > 0;
};

const keyUpEventHandler = (event: KeyboardEvent, index: number) => {
    if (event.key == "Delete" || event.key == "Backspace") {
        if (index > 0) {
            inputRefs.value[index - 1].setSelectionRange(1, 1);
            inputRefs.value[index - 1].focus();
        }
    } else if ((event.key >= "0" && event.key <= "9") || event.key == "Unidentified") {
        if (event.key >= "0" && event.key <= "9") {
            if (isSecondLetter) {
                inputValues[index + 1].value = event.key;
            } else if (inputValues[index].value != event.key) {
                inputValues[index].value = event.key;
            }
        }

        if (index < inputRefs.value.length - 1) {
            inputRefs.value[index + 1].setSelectionRange(0, 0);
            inputRefs.value[index + 1].focus();
        } else {
            inputRefs.value[index].blur();
        }
    }
};

/* ****************** END CRAZY SOLUTION ********************* */

const resendPin = () => {
    emit("resendPin");
};

const pinResendedInternal = ref(false);
const pinResendedSuccess = ref(false);
const pinResended = (success: boolean) => {
    pinResendedInternal.value = true;
    pinResendedSuccess.value = success;
};

onMounted(() => {
    inputRefs.value[0].focus();
});

const checkCode = (code: string) => /^(\d{4})$/.test(code);

const errorMessage = _useModel<string>(__props, "errorMessage");

const checkIfIsValid = (): boolean => {
    let isValid = true;

    const code = getCode();

    if (!code) {
        errorMessage.value = "Vyplňte prosím kód.";
        isValid = false;
    } else if (!checkCode(code)) {
        errorMessage.value = "Pin není zadaný správně.";
        isValid = false;
    }

    return isValid;
};

__expose({
    pinResended,
    checkIfIsValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AccountInput, {
      class: "pin-input__enter",
      errorMessage: errorMessage.value,
      name: _ctx.name,
      onInputErrorDetected: _cache[0] || (_cache[0] = ($event: any) => (emit('inputErrorDetected', _ctx.name, errorMessage.value)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inputValues, (_, index) => {
            return _withDirectives(_createElementVNode("input", {
              class: "pin-input__field-input",
              type: "text",
              inputmode: "numeric",
              placeholder: "",
              maxlength: "1",
              key: 'pin-input' + index,
              ref_for: true,
              ref_key: "inputRefs",
              ref: inputRefs,
              "onUpdate:modelValue": ($event: any) => ((inputValues[index].value) = $event),
              onKeydown: (event) => keyDownEventHandler(event, index),
              onKeyup: (event) => keyUpEventHandler(event, index)
            }, null, 40, _hoisted_3), [
              [_vModelText, inputValues[index].value]
            ])
          }), 64))
        ])
      ]),
      _: 1
    }, 8, ["errorMessage", "name"]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createTextVNode(" Na ")),
      (_ctx.phoneNumber)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _cache[1] || (_cache[1] = _createTextVNode(" číslo ")),
            _createElementVNode("b", null, _toDisplayString(phoneNumberFormatted.value), 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, " vaše číslo ")),
      _cache[3] || (_cache[3] = _createTextVNode(" jsme odeslali 4místný PIN kód. Zadejte ho prosím. "))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!pinResendedInternal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createTextVNode(" Kód mi nepřišel. ")),
            _createElementVNode("a", {
              onClick: resendPin,
              class: "pin-input__resend-link"
            }, "Odeslat znovu")
          ]))
        : (pinResendedInternal.value && pinResendedSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "ODESLÁNO"))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, "ODESLÁNÍ SELHALO"))
    ])
  ]))
}
}

})